import { render, staticRenderFns } from "./ProductsSkeleton.vue?vue&type=template&id=3c509065"
import script from "./ProductsSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports